import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography';
import { Deductibles } from '../../types';
import './InsuranceVerificationDetails.scss';

type props = {
  deductibles: Deductibles;
  className?: string;
};

export const InsuranceDeductible: React.FC<props> = ({
  deductibles,
  className,
}: props) => {
  const { t } = useTranslation('insuranceVerification');

  return (
    <div className={`card-container ${className || ''}`}>
      <Typography variant="size-18" color="color-2">
        {t('insuranceDeductible.title')}
      </Typography>

      <div className="row">
        <div className="col d-flex flex-column justify-content-between">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            className="mt-3"
            textTransform="uppercase"
          >
            {t('insuranceDeductible.planIndividualDeductibleLabel')}
          </Typography>

          <Typography
            variant="size-26"
            weight="bold"
            color="color-2"
            className="mt-1"
          >
            {deductibles?.plan_individual_deductible}
          </Typography>
        </div>

        <div className="col d-flex flex-column justify-content-between">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            className="mt-3"
            textTransform="uppercase"
          >
            {t('insuranceDeductible.amountAppliedDeductibleLabel')}
          </Typography>

          <Typography
            variant="size-26"
            weight="bold"
            color="color-2"
            className="mt-1"
          >
            {deductibles?.amount_applied_to_deductible}
          </Typography>
        </div>

        <div className="col d-flex flex-column justify-content-between">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            className="mt-3"
            textTransform="uppercase"
          >
            {t('insuranceDeductible.remainingDeductibleLabel')}
          </Typography>

          <Typography
            variant="size-26"
            weight="bold"
            color="color-2"
            className="mt-1"
          >
            {deductibles?.deductible_remaining}
          </Typography>
        </div>
      </div>

      <Typography variant="size-14" color="color-28" className="mt-2">
        {t('insuranceDeductible.description')}
      </Typography>
    </div>
  );
};
